// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main_dashboard_component {
    background-color: #F2F2F2;
    /* height: calc(100vh - 60px - 60px); */
    width: calc(100vw - 241px - 60px);
    overflow-y: scroll;
  }
  
  .main_dashboard_component {
    scrollbar-width: none;
   -ms-overflow-style: none;

   height: 100vh
 }
 
 .main_dashboard_component::-webkit-scrollbar {
   display: none;
 }
  
  .main_dashboard_fleet_vehicle {
    display: flex;
    flex-direction: row;
  }
  
  .fleet_vehicle_detail_card {
    background-color: white;
    width: 23%;
    margin-top: 1%;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
    padding-bottom: 0.5%;
  }
  .fleet_vehicle_detail_head{
  /* font-family: ; */
    font-size: 0.85vw;
    margin-left: 8%;
    margin-top: 2%;
    color: #4A4D57;
  }
  .fleet_vehicle_detail_value,.fleet_vehicle_online_detail_value,.fleet_vehicle_offline_detail_value,.fleet_vehicle_attention_detail_value {
    font-family: Poppins;
    font-size: 1.4vw;
    font-weight: 600;
    margin-left: 8%;
    color: #3174A4;
  }
  .fleet_vehicle_online_detail_value {
    color: #62AD41;
  }
  
  .fleet_vehicle_offline_detail_value {
    color: #828799;
  }
  .fleet_vehicle_attention_detail_value {
    color: #F75D5D;
  }
  
  .operations_card {
    background-color: white;
    Width: 48.5%;
    height:33.5vh;
    border-top: 2px solid #93BA45;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-bottom: 3vh;
    /* margin-left: 30px; */
  }
  
  .operation_card_detail_header {
    display: flex;
    flex-direction: row;
    padding-bottom: -1px; 
    border-bottom: 1px solid rgba(128, 128, 128, 0.244);
  }
  
  .operation_card_detail_footer {
    display: flex;
    flex-direction: row;
    padding-top: 2px;
    margin-bottom: 3px;
    border-top: 1px solid rgba(128, 128, 128, 0.244);
    padding-left: 10px;
  }
  
  .main_dashboard_fleet_vehicle_lower {
    margin-top: 3vh;
    /* margin-left: 2.5vw; */
    display: flex;
    flex-wrap: wrap;
  }
  .operation_card_detail_header_title{
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #4A4D57;
    margin-top: 0.4vh;
    margin-left: 10px;
  }
  
  .information_icon {
    margin-left: 4px;
    margin-top: 0.5vh;
  }
  
  .live_dot_card {
    width: 5px;
    height: 5px;
    background: #D50D00;
    border-radius: 50%;
    margin-top: 17px;
    margin-left: 10px;
  }
  
  .live_status_text {
    font-weight: 400;
    font-size: 13px;
    line-height: 21px;
    color: #D50D00;
    margin-top: 9px;
    margin-left: 4px;
  }
  
  .on_trip_operation_color_details {
    display: flex;
    flex-direction: row;
    padding-right: 15px;
    font-weight: 500;
    font-size: 10px;
    line-height: 20px;
    color: #828799;
  }
  
  .on_trip_light_blue_dot,.speedreddot {
    width: 8px;
    height: 8px;
    background: #3295F1;
    margin-top: 5px;
    margin-right: 5px;  
  }
  .speedreddot {
    background-color: #800800;
  }
  .avilable_blue_dot{
    width: 8px;
    height: 8px;
    background: #7EBBF3;
    margin-top: 5px;
    margin-right: 5px; 
  }
  
  .on_trip_medium_blue_dot,  .on_trip_high_blue_dot, .on_trip_low_blue_dot, .batteryColor{
    width: 8px;
    height: 8px;
    background: #BA3029;
    margin-top: 5px;
    margin-right: 5px;  
  }
  #chartContainer .apexcharts-tooltip {
    color: #000000;
  }
  
  #chartContainer .apexcharts-tooltip .apexcharts-tooltip-series-group.active {
    background: #ffffff !important;
  }

  .arrow_box {
    padding: 10px;
    font-size: 0.7vw;
  }
  .on_trip_high_blue_dot {
    background: #D65D59;
  }

  .on_trip_low_blue_dot {
    background: #7EBBF3;
  }

  .batteryColor{
    background-color: #F89191;
  }

  
  
  .on_trip_green_dot,.good_green_dot {
    width: 8px;
    height: 8px;
    background: #83B148;
    margin-top: 5px;
    margin-right: 5px;  
  }
  .on_trip_red_dot,.bad_red_dot {
    width: 8px;
    height: 8px;
    background: #F24A4A;
    margin-top: 5px;
    margin-right: 5px;  
  }
  .moderate_orange_dot {
    width: 8px;
    height: 8px;
    background: #FFBF5E;
    margin-top: 5px;
    margin-right: 5px; 
  }
  .donut_chart_data {
    display: flex;
  }
  .donut_chart_view {
    margin-left: 4vw;
  }
  .donut_chart_info_avilable {
    margin-top: 3.8vw;
    margin-left: 7vw;
  }
  .avilable_trip_head{
    font-weight: 400;
    font-size: 1vw;
    text-align: center;      
    color: #ABB5C1;
  }
  .avilable_trip_value {
    font-weight: 600;
    font-size: 1vw;
    text-align: center;
    letter-spacing: 0.05em;
    color: #828799;
  }
  `, "",{"version":3,"sources":["webpack://./src/Components/Home/index.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,uCAAuC;IACvC,iCAAiC;IACjC,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;GACtB,wBAAwB;;GAExB;CACF;;CAEA;GACE,aAAa;CACf;;EAEC;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,UAAU;IACV,cAAc;IACd,0CAA0C;IAC1C,oBAAoB;EACtB;EACA;EACA,mBAAmB;IACjB,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,cAAc;EAChB;EACA;IACE,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,cAAc;EAChB;EACA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;;EAEA;IACE,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,6BAA6B;IAC7B,0CAA0C;IAC1C,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,mDAAmD;EACrD;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,gDAAgD;IAChD,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,wBAAwB;IACxB,aAAa;IACb,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,cAAc;EAChB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B;;;;EAIA;IACE,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,cAAc;EAChB;EACA;IACE,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;EAChB","sourcesContent":[".main_dashboard_component {\r\n    background-color: #F2F2F2;\r\n    /* height: calc(100vh - 60px - 60px); */\r\n    width: calc(100vw - 241px - 60px);\r\n    overflow-y: scroll;\r\n  }\r\n  \r\n  .main_dashboard_component {\r\n    scrollbar-width: none;\r\n   -ms-overflow-style: none;\r\n\r\n   height: 100vh\r\n }\r\n \r\n .main_dashboard_component::-webkit-scrollbar {\r\n   display: none;\r\n }\r\n  \r\n  .main_dashboard_fleet_vehicle {\r\n    display: flex;\r\n    flex-direction: row;\r\n  }\r\n  \r\n  .fleet_vehicle_detail_card {\r\n    background-color: white;\r\n    width: 23%;\r\n    margin-top: 1%;\r\n    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);\r\n    padding-bottom: 0.5%;\r\n  }\r\n  .fleet_vehicle_detail_head{\r\n  /* font-family: ; */\r\n    font-size: 0.85vw;\r\n    margin-left: 8%;\r\n    margin-top: 2%;\r\n    color: #4A4D57;\r\n  }\r\n  .fleet_vehicle_detail_value,.fleet_vehicle_online_detail_value,.fleet_vehicle_offline_detail_value,.fleet_vehicle_attention_detail_value {\r\n    font-family: Poppins;\r\n    font-size: 1.4vw;\r\n    font-weight: 600;\r\n    margin-left: 8%;\r\n    color: #3174A4;\r\n  }\r\n  .fleet_vehicle_online_detail_value {\r\n    color: #62AD41;\r\n  }\r\n  \r\n  .fleet_vehicle_offline_detail_value {\r\n    color: #828799;\r\n  }\r\n  .fleet_vehicle_attention_detail_value {\r\n    color: #F75D5D;\r\n  }\r\n  \r\n  .operations_card {\r\n    background-color: white;\r\n    Width: 48.5%;\r\n    height:33.5vh;\r\n    border-top: 2px solid #93BA45;\r\n    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-between;\r\n    margin-bottom: 3vh;\r\n    /* margin-left: 30px; */\r\n  }\r\n  \r\n  .operation_card_detail_header {\r\n    display: flex;\r\n    flex-direction: row;\r\n    padding-bottom: -1px; \r\n    border-bottom: 1px solid rgba(128, 128, 128, 0.244);\r\n  }\r\n  \r\n  .operation_card_detail_footer {\r\n    display: flex;\r\n    flex-direction: row;\r\n    padding-top: 2px;\r\n    margin-bottom: 3px;\r\n    border-top: 1px solid rgba(128, 128, 128, 0.244);\r\n    padding-left: 10px;\r\n  }\r\n  \r\n  .main_dashboard_fleet_vehicle_lower {\r\n    margin-top: 3vh;\r\n    /* margin-left: 2.5vw; */\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n  }\r\n  .operation_card_detail_header_title{\r\n    font-weight: 400;\r\n    font-size: 14px;\r\n    line-height: 21px;\r\n    color: #4A4D57;\r\n    margin-top: 0.4vh;\r\n    margin-left: 10px;\r\n  }\r\n  \r\n  .information_icon {\r\n    margin-left: 4px;\r\n    margin-top: 0.5vh;\r\n  }\r\n  \r\n  .live_dot_card {\r\n    width: 5px;\r\n    height: 5px;\r\n    background: #D50D00;\r\n    border-radius: 50%;\r\n    margin-top: 17px;\r\n    margin-left: 10px;\r\n  }\r\n  \r\n  .live_status_text {\r\n    font-weight: 400;\r\n    font-size: 13px;\r\n    line-height: 21px;\r\n    color: #D50D00;\r\n    margin-top: 9px;\r\n    margin-left: 4px;\r\n  }\r\n  \r\n  .on_trip_operation_color_details {\r\n    display: flex;\r\n    flex-direction: row;\r\n    padding-right: 15px;\r\n    font-weight: 500;\r\n    font-size: 10px;\r\n    line-height: 20px;\r\n    color: #828799;\r\n  }\r\n  \r\n  .on_trip_light_blue_dot,.speedreddot {\r\n    width: 8px;\r\n    height: 8px;\r\n    background: #3295F1;\r\n    margin-top: 5px;\r\n    margin-right: 5px;  \r\n  }\r\n  .speedreddot {\r\n    background-color: #800800;\r\n  }\r\n  .avilable_blue_dot{\r\n    width: 8px;\r\n    height: 8px;\r\n    background: #7EBBF3;\r\n    margin-top: 5px;\r\n    margin-right: 5px; \r\n  }\r\n  \r\n  .on_trip_medium_blue_dot,  .on_trip_high_blue_dot, .on_trip_low_blue_dot, .batteryColor{\r\n    width: 8px;\r\n    height: 8px;\r\n    background: #BA3029;\r\n    margin-top: 5px;\r\n    margin-right: 5px;  \r\n  }\r\n  #chartContainer .apexcharts-tooltip {\r\n    color: #000000;\r\n  }\r\n  \r\n  #chartContainer .apexcharts-tooltip .apexcharts-tooltip-series-group.active {\r\n    background: #ffffff !important;\r\n  }\r\n\r\n  .arrow_box {\r\n    padding: 10px;\r\n    font-size: 0.7vw;\r\n  }\r\n  .on_trip_high_blue_dot {\r\n    background: #D65D59;\r\n  }\r\n\r\n  .on_trip_low_blue_dot {\r\n    background: #7EBBF3;\r\n  }\r\n\r\n  .batteryColor{\r\n    background-color: #F89191;\r\n  }\r\n\r\n  \r\n  \r\n  .on_trip_green_dot,.good_green_dot {\r\n    width: 8px;\r\n    height: 8px;\r\n    background: #83B148;\r\n    margin-top: 5px;\r\n    margin-right: 5px;  \r\n  }\r\n  .on_trip_red_dot,.bad_red_dot {\r\n    width: 8px;\r\n    height: 8px;\r\n    background: #F24A4A;\r\n    margin-top: 5px;\r\n    margin-right: 5px;  \r\n  }\r\n  .moderate_orange_dot {\r\n    width: 8px;\r\n    height: 8px;\r\n    background: #FFBF5E;\r\n    margin-top: 5px;\r\n    margin-right: 5px; \r\n  }\r\n  .donut_chart_data {\r\n    display: flex;\r\n  }\r\n  .donut_chart_view {\r\n    margin-left: 4vw;\r\n  }\r\n  .donut_chart_info_avilable {\r\n    margin-top: 3.8vw;\r\n    margin-left: 7vw;\r\n  }\r\n  .avilable_trip_head{\r\n    font-weight: 400;\r\n    font-size: 1vw;\r\n    text-align: center;      \r\n    color: #ABB5C1;\r\n  }\r\n  .avilable_trip_value {\r\n    font-weight: 600;\r\n    font-size: 1vw;\r\n    text-align: center;\r\n    letter-spacing: 0.05em;\r\n    color: #828799;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
